import { FormatNumberOptions } from 'react-intl'

export const getFormatOptionNumber = (): FormatNumberOptions => {
  return {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  }
}
